module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    ref: "from",
    attrs: {
      "label": "Naziv radnje",
      "required": "",
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.delivery.from_name),
      callback: function($$v) {
        _vm.$set(_vm.delivery, "from_name", $$v)
      },
      expression: "delivery.from_name"
    }
  }), _vm._v(" "), _c('addresss', {
    attrs: {
      "label": "Adresa radnje",
      "suggestions": _vm.streets,
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.delivery.from_address),
      callback: function($$v) {
        _vm.$set(_vm.delivery, "from_address", $$v)
      },
      expression: "delivery.from_address"
    }
  }), _vm._v(" "), _c('v-text-field', {
    ref: "to",
    attrs: {
      "label": "Telefon primaoca",
      "type": "tel"
    },
    on: {
      "input": _vm.autocompleteRecipient
    },
    model: {
      value: (_vm.delivery.recipient_phone),
      callback: function($$v) {
        _vm.$set(_vm.delivery, "recipient_phone", $$v)
      },
      expression: "delivery.recipient_phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Ime primaoca",
      "required": ""
    },
    model: {
      value: (_vm.delivery.to_name),
      callback: function($$v) {
        _vm.$set(_vm.delivery, "to_name", $$v)
      },
      expression: "delivery.to_name"
    }
  }), _vm._v(" "), _c('addresss', {
    attrs: {
      "label": "Adresa primaoca",
      "suggestions": _vm.streets
    },
    model: {
      value: (_vm.delivery.to_address),
      callback: function($$v) {
        _vm.$set(_vm.delivery, "to_address", $$v)
      },
      expression: "delivery.to_address"
    }
  }), _vm._v(" "), _c('timepicker', {
    attrs: {
      "label": "Vreme preuzimanja",
      "templates": "15,30,45"
    },
    model: {
      value: (_vm.delivery.time_targeted_pickup),
      callback: function($$v) {
        _vm.$set(_vm.delivery, "time_targeted_pickup", $$v)
      },
      expression: "delivery.time_targeted_pickup"
    }
  }), _vm._v(" "), _c('timepicker', {
    attrs: {
      "label": "Vreme dostave",
      "templates": "30,45,60,90"
    },
    model: {
      value: (_vm.delivery.time_targeted_delivery),
      callback: function($$v) {
        _vm.$set(_vm.delivery, "time_targeted_delivery", $$v)
      },
      expression: "delivery.time_targeted_delivery"
    }
  }), _vm._v(" "), _c('v-textarea', {
    staticClass: "mt-2",
    attrs: {
      "label": "Napomene",
      "outline": "",
      "rows": "2",
      "auto-grow": ""
    },
    model: {
      value: (_vm.delivery.description),
      callback: function($$v) {
        _vm.$set(_vm.delivery, "description", $$v)
      },
      expression: "delivery.description"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mt-0 mb-5",
    attrs: {
      "large": "",
      "block": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("sačuvaj")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "error"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_vm._v("Došlo je do greške, pokušajte ponovo ili kontaktirajte podršku")]), _vm._v(" "), _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "bottom": "",
      "large": "",
      "block": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_vm._v("nazad")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}